import { memo, useContext } from "react";
import { List } from "@mui/material";
import ResponsiveDialog from "./ResponsiveDialog.js";
import DialogOptionRow from "./DialogOptionRow.js";
import { useTimelineContent } from "src/utils/useTimelineContent.js";
import { AuthContext } from "src/utils/AuthContext.js";
import CalendarSelect from "../CalendarSelect.js";

const AddToCalendarDialog = ({
  open,
  handleClose,
  handleAddToCalendar,
  handleAddToGroup,
  calendarId,
  handle,
  calendars,
  selectedCalendar,
  setSelectedCalendar,
  isEventCard,
}) => {
  const { user } = useContext(AuthContext);

  const BottomDialogSx = {
    ".MuiPaper-root": { height: "298px" },
    ".MuiDialogContent-root": { padding: "0px" },
    ".MuiDialogTitle-root": { margin: isEventCard ? "0" : "auto" },
  };

  const CenterDialogSx = {
    ".MuiPaper-root": { maxWidth: "393px" },
    ".MuiDialogContent-root": { padding: "0px" },
    ".MuiDialogTitle-root": { margin: isEventCard ? "0" : "auto" },
  };

  const DialogContent = () => {
    return (
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        <DialogOptionRow
          icon="calendar_add_on"
          primary="Add to Calendar"
          secondary="Add all upcoming events to your calendar app to keep up with new events and updates."
          testId="add-to-calendar-confirm"
          onClick={() => {
            handleAddToCalendar(selectedCalendar);
            handleClose();
          }}
        />
        <DialogOptionRow
          icon="folder"
          primary="Add to Group"
          secondary="Seamlessly merge multiple calendars into one with Groups."
          testId="add-to-group-confirm"
          onClick={() => {
            handleAddToGroup(selectedCalendar);
            handleClose();
          }}
        />
      </List>
    );
  };

  return (
    <ResponsiveDialog
      open={open}
      handleClose={handleClose}
      dialogTitle={
        isEventCard ? (
          selectedCalendar?.name
        ) : (
          <CalendarSelect
            setSelectedCalendar={setSelectedCalendar}
            user={user}
            selectedCalendar={selectedCalendar}
            calendars={calendars}
            checkSubscriptionStatus={true}
          />
        )
      }
      dividers
      bottomProps={{ sx: BottomDialogSx }}
      centerProps={{ sx: CenterDialogSx }}
    >
      <DialogContent />
    </ResponsiveDialog>
  );
};

export const TimelineWrapper = (Children) => {
  const HocComponent = ({ ...props }) => {
    const { calendars, selectedCalendar, setSelectedCalendar } =
      useTimelineContent({
        handle: props.handle,
        calendarId: props.calendarId,
        refetch: false,
      });
    const targetCalendar = props.isEventCard
      ? props.initialCalendar
      : selectedCalendar;
    if (!calendars || !selectedCalendar) return <></>;
    return (
      <Children
        {...props}
        calendars={calendars}
        selectedCalendar={targetCalendar}
        setSelectedCalendar={setSelectedCalendar}
      />
    );
  };

  return HocComponent;
};

export default TimelineWrapper(
  memo(AddToCalendarDialog, (prevProps, nextProps) => {
    return (
      prevProps.open === nextProps.open &&
      prevProps.handle === nextProps.handle &&
      prevProps.calendarId === nextProps.calendarId &&
      prevProps.selectedCalendar?._id === nextProps.selectedCalendar?._id
    );
  })
);
